import scrollIntoViewWithOffset from '../utils/scrollIntoViewWithOffset';

const initNewsletter = () => {
  const successMessage = document.getElementById('newsletter-success-message');
  
  if (successMessage) {
    // Small delay to ensure page is fully rendered
    setTimeout(() => {
      scrollIntoViewWithOffset('#newsletter-success-message', 100);
    }, 100);
  }
};

export default initNewsletter;
